import script from "./AdminLockModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLockModal.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLockModal.vue?vue&type=style&index=0&id=50586fe8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50586fe8"]])

export default __exports__